module.exports = __webpack_public_path__ + "img/plus.dbbc322f.svg";